import { PropsWithChildren, MouseEvent } from 'react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { IntuiAlertDialogAction } from '@/components/intueri/IntuiAlertDialog'
import { useTranslation } from '@/i18n'

interface ConfirmDeleteDialogProps extends PropsWithChildren {
  onConfirmDelete: (e: MouseEvent<HTMLButtonElement>) => void
  type?: string
}

const ConfirmDeleteDialog = ({
  onConfirmDelete,
  children,
  type,
}: ConfirmDeleteDialogProps) => {
  const { t } = useTranslation()
  const rawType = type || 'document'
  // Resolve the raw type enum (e.g. "pnid", "timeseries") to its display
  // label ("P&ID", "Time Series") via the same map the DataTable uses, so the
  // delete modal matches what the user sees in the catalog. Falls back to the
  // raw value for any type not present in the map.
  const itemType = t(`data_catalog:doc_types.${rawType}`, { defaultValue: rawType })

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild onClick={(e) => e.stopPropagation()}>
        {children}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('common:delete_dialog.title', { type: itemType })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('common:delete_dialog.description', { type: itemType })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={(e) => e.stopPropagation()}>
            {t('common:delete_dialog.cancel')}
          </AlertDialogCancel>
          <IntuiAlertDialogAction
            variant="destructive"
            onClick={(e) => onConfirmDelete(e)}
          >
            {t('common:delete_dialog.delete')}
          </IntuiAlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ConfirmDeleteDialog
